import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'catalogs',
    name: 'manager-catalogs',
    component: () =>
      import('../../../views/Manager/Catalog/ManagerCatalogItems.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'catalogs/:id?/general',
    name: 'manager-catalogs-item-general',
    component: () =>
      import('../../../views/Manager/Catalog/ManagerCatalogItemGeneral.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'catalogs/:id?/seo',
    name: 'manager-catalogs-item-seo',
    component: () =>
      import('../../../views/Manager/Catalog/ManagerCatalogItemSeo.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'catalogs/:id?/presets',
    name: 'manager-catalogs-item-presets',
    component: () =>
      import('../../../views/Manager/Catalog/ManagerCatalogItemPresets.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'catalogs/:id?/presets/:presetId?/form',
    name: 'manager-catalogs-item-preset-form',
    component: () =>
      import('../../../views/Manager/Catalog/ManagerCatalogItemPresetForm.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'catalogs/:id?/single-product',
    name: 'manager-catalogs-item-single-product',
    component: () =>
      import(
        '../../../views/Manager/Catalog/ManagerCatalogItemSingleProduct.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'catalogs/:id?/merchandising',
    name: 'manager-catalogs-item-merchandising',
    component: () =>
      import(
        '../../../views/Manager/Catalog/ManagerCatalogItemMerchandising.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
